module.exports = __webpack_public_path__ + "img/dialog-bg.20a10328.png";